import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import Zoom from '@mui/material/Zoom';
import { useSelector } from 'react-redux';

export const TooltipHtml = styled(
  ({ className, enterDelay, enterNextDelay, ...props }) => {
    const effectiveEnterDelay =
      typeof enterDelay === 'number' ? enterDelay : 0;
    const effectiveEnterNextDelay =
      typeof enterNextDelay === 'number' ? enterNextDelay : effectiveEnterDelay;

    return (
      <Tooltip
        {...props}
        classes={{ popper: className }}
        arrow
        leaveDelay={200}
        TransitionComponent={Zoom}
        enterTouchDelay={0}
        enterDelay={effectiveEnterDelay}
        enterNextDelay={effectiveEnterNextDelay}
      />
    );
  }
)(({ theme }) => {
  const themeColor = useSelector(state => state.global.theme);
  return {
    zIndex: 9999,
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: `rgba(${themeColor['main-d']?.replaceAll(' ', ',')}, 1)`,
    },
    [`& .${tooltipClasses.arrow}:before`]: {
      backgroundColor: `rgba(${themeColor['main-d']?.replaceAll(' ', ',')}, 1)`,
    },
  };
});
